<div class="u-pt30" [ngClass]="{'u-lock': !enabled}">
  <div class="row" *ngIf="showTitle">
    <div class="col-md-12 u-mb30">
      <h2 class="txt txt--section">
        {{numberSection}}. Información sobre aprobación
      </h2>
      <h3 class="txt txt--paragraph">
        Adjunta los documentos requeridos
      </h3>
    </div>
  </div>
  <div class="row" >
    <div  *ngIf="shouldRequireSI" class="col-md-4 order-md-1 order-1">
      <div class="form form--required u-mb20">
        <label for="" class="label label-license" style="margin-bottom: 0px !important;">
          Superintendente
          <h6 class="txt txt--paragraph" style="position: absolute;">
            Selecciona al superintendente que aprueba la solicitud.
          </h6>
          <h6 class="txt txt--paragraph" style="opacity: 0; color: transparent">
            Selecciona el área del equipo que gestionará esta solicitud
            <!-- (Operaciones/proyectos) -->
            {{!this.assetId ? '(Operaciones/proyectos).' : ''}}
            {{this.assetId == 1 ? '(Operaciones/proyectos).' : ''}}
            {{this.assetId == 2 ? ':Operaciones (Acredita) o Proyectos (STWM, SGO, SCU, otros).' : ''}}
          </h6>
        </label>
        <app-select-list
          #SuperintendentComponent
          hintText="*El rut debe ser sin puntos y con guión"
          [optional]="true" (textInputValueEmitter)="onSearchSuperintendentTextChange($event)"
          [optionList]="listSuperintendentOptions"
          placeHolder="Buscar por nombre, rut* o email"
          (selectedValueEmitter)="onSearchSuperintendentSelected($event)"
          [isLoading]="loadingPersonOptions"
          [color]="colorBoxes"
          [controlForm]="this.superintendentIdFormControl"
        >
        </app-select-list>
      </div>
    </div>
    <div class="col-md-4 order-md-2 order-3">
      <div class="form form--required u-mb20">
        <label for="" class="label">
          Gestor de solicitud <app-tooltip
            [text]="getRequestManagerTooltip(this.assetId)"></app-tooltip>
          <h6 class="txt txt--paragraph">
            Selecciona el área del equipo que gestionará esta solicitud
          <!-- (Operaciones/proyectos) -->
          {{!this.assetId ? '(Operaciones/proyectos).' : ''}}
          {{this.assetId == 1 ? '(Operaciones/proyectos).' : ''}}
          {{this.assetId == 2 ? ':Operaciones (Acredita) o Proyectos (STWM, SGO, SCU, otros).' : ''}}
          </h6>
        </label>
        <select [formControl]="managerFormControl" id="" [ngClass]="colorBoxes == 'white' ? 'form--white' : ''">
          <option value="">Selecciona</option>
          <option *ngFor="let manager of managersDataByAsset; index as i;" value="{{manager.id}}">{{manager.name}}
          </option>
        </select>
      </div>
    </div>
    <div class="col-md-12 order-md-3 order-2">
    </div>
  </div>
</div>
